import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ShoppingBagIcon } from 'lucide-react';
interface CinematicHeaderProps {
  onNavigate: (page: string) => void;
  currentPage: string;
  cartItemCount?: number;
}
export function CinematicHeader({
  onNavigate,
  currentPage,
  cartItemCount = 0
}: CinematicHeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Home', 'Experience', 'Menu', 'Events', 'Gallery'];
  const handleNavClick = (link: string) => {
    onNavigate(link.toLowerCase());
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-md py-4' : 'bg-transparent py-6'}`} data-id="element-13">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-14">
          <button onClick={() => handleNavClick('home')} className="text-gold font-serif tracking-ultra-wide font-bold text-[22px] md:text-[26px] z-50 hover:opacity-80 transition-opacity" data-id="element-15">
            TEMPOO
          </button>

          <nav className="hidden md:flex items-center gap-8" data-id="element-16">
            {navLinks.map(link => {
            const isActive = currentPage === link.toLowerCase();
            return <button key={link} onClick={() => handleNavClick(link)} className={`font-sans uppercase tracking-widest text-base font-medium transition-colors duration-300 ${isActive ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-17">
                  {link}
                </button>;
          })}

            {/* Cart Icon */}
            <button onClick={() => handleNavClick('cart')} className="relative text-white hover:text-gold transition-colors duration-300" aria-label="Shopping cart" data-id="element-18">
              <ShoppingBagIcon size={22} data-id="element-19" />
              {cartItemCount > 0 && <span className="absolute -top-2 -right-2 w-5 h-5 bg-gold text-black text-[10px] font-bold font-sans rounded-full flex items-center justify-center" data-id="element-20">
                  {cartItemCount}
                </span>}
            </button>

            <button className="border border-gold text-gold px-6 py-2 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 hover:animate-glow transition-all duration-300" data-id="element-21">
              Reserve Now
            </button>
          </nav>

          {/* Mobile: Cart + Hamburger */}
          <div className="md:hidden flex items-center gap-4 z-50" data-id="element-22">
            <button onClick={() => handleNavClick('cart')} className="relative text-gold" aria-label="Shopping cart" data-id="element-23">
              <ShoppingBagIcon size={24} data-id="element-24" />
              {cartItemCount > 0 && <span className="absolute -top-2 -right-2 w-5 h-5 bg-gold text-black text-[10px] font-bold font-sans rounded-full flex items-center justify-center" data-id="element-25">
                  {cartItemCount}
                </span>}
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" className="text-gold" data-id="element-26">
              {isMobileMenuOpen ? <XIcon size={28} data-id="element-27" /> : <MenuIcon size={28} data-id="element-28" />}
            </button>
          </div>
        </div>
      </header>

      <div className={`fixed inset-0 bg-black z-40 flex flex-col items-center justify-center transition-opacity duration-500 ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} data-id="element-29">
        <nav className="flex flex-col items-center gap-8" data-id="element-30">
          {navLinks.map(link => {
          const isActive = currentPage === link.toLowerCase();
          return <button key={link} onClick={() => handleNavClick(link)} className={`font-sans uppercase tracking-mega-wide text-xl font-medium transition-colors duration-300 ${isActive ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-31">
                {link}
              </button>;
        })}
          <button onClick={() => handleNavClick('cart')} className="font-sans uppercase tracking-mega-wide text-xl font-medium text-white hover:text-gold transition-colors duration-300 flex items-center gap-3" data-id="element-32">
            Cart
            {cartItemCount > 0 && <span className="w-6 h-6 bg-gold text-black text-xs font-bold rounded-full flex items-center justify-center" data-id="element-33">
                {cartItemCount}
              </span>}
          </button>
          <button className="mt-8 border border-gold text-gold px-8 py-3 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-34">
            Reserve Now
          </button>
        </nav>
      </div>
    </>;
}